import { setupGoogletag, setupTargeting } from "./helpers/googletag";
import { setupGtm, setGtmPageViewEvent } from "./helpers/gtm";
import { setupStimulus } from "./helpers/stimulus";
import { carFinder } from "./components/car-finder";
import { workaroundWebkitBug } from "./helpers/workarounds"
import { pruneBonzai, setupTruskinObserver } from "./helpers/bonzai"
import { setupAdRefresh } from "./helpers/ad-refresh"

// Setup
setupGtm();
setupGoogletag();
setupStimulus();
window.addEventListener("load", function() {
  pruneBonzai();
  setupTargeting();
  setupAdRefresh();
  setupTruskinObserver();
  workaroundWebkitBug();
  setGtmPageViewEvent();
});

// Components
carFinder();